import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicParsevalsIdentity = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Parseval's Identity"
      videos={[
       
        "https://www.youtube.com/embed/jX6maLqK-04",
      ]}
      takeaways={[
        

      ]} // Add key takeaways if needed
      questions={[]} // Add questions if needed
      exampleVideos={[]} // Add example question videos if needed
    />
);
}

export default ModuleSubtopicParsevalsIdentity;
